import React, { useState } from 'react';
import '../styles/AboutUs.css';
import team from '../images/assets/team.jpeg'

const AboutUs = () => {
  const [phone, setPhone] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(phone)) {
      setError('Please enter a valid 10-digit phone number');
      return;
    }
    // API call simulation
    setError('');
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <>
    <title>Zuri Lands Investment Limited - About Us</title>
    <div className="about-container">
      {/* Intro Section */}
      <section className="intro-section">
      <div className="intro__content">
      <h1 className="intro__heading">Welcome to Zuri Land Investments</h1>
          <img 
            src={team} 
            alt="Our Team" 
            className="intro__image"
          />
          <p className="intro__text">
          At Zuri Land Investments, we believe every Kenyan deserves a chance to own land—whether for building a home, 
          investing, or securing a legacy. Our projects in Matuu and Malindi are carefully selected for their location, 
          value, and potential for growth. We are committed to transparency, flexible payment plans, and delivering genuine, 
          title-ready plots. From free daily site visits to hassle-free documentation, we make your land-buying journey 
          smooth and secure.
          </p>
          <p className="intro__text">
          We are guided by a customer-centric approach that puts your needs at the core of our service. From the moment you engage 
          with us, we ensure personalized attention, honest guidance, and full support through every step of the acquisition process. 
          With integrity and transparency as our foundation, we keep all processes clear, documentation accurate, and communication 
          open. Our goal is to build lasting relationships based on trust and satisfaction.
          </p>
        </div>
      </section>

            {/* Mission and Vision Section */}
            <div className="mission-vision">
                <div className="mission">
                    <h2>Our Mission</h2>
                    <p>To empower Kenyans through land ownership.</p>
                </div>
                <div className="vision">
                    <h2>Our Vision</h2>
                    <p>To be the one stop shop for all your real estate needs.</p>
                </div>
            </div>      

      {/* Callback Form */}
      <section className="callback-section">
        <h2 className="callback__title">Request a Callback</h2>
        <form onSubmit={handleSubmit} className="callback__form">
          <div className="form__group">
            <label htmlFor="phone" className="form__label">
              Phone Number
            </label>
            <input
              type="tel"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="form__input"
              placeholder="Enter 10-digit number"
              pattern="\d{10}"
              required
            />
          </div>
          {error && <p className="form__error">{error}</p>}
          {submitted && <p className="form__success">We'll call you shortly!</p>}
          <button type="submit" className="form__button">
            Request Call
          </button>
        </form>
      </section>
    </div>
    </>
  );
};

export default AboutUs;